module.exports = __webpack_public_path__ + "img/lukas.4b8f6991.png";